module.exports = __webpack_public_path__ + "img/watkostdat.a65d9470.png";